<div class="outer-container">
  <app-current-path></app-current-path>
  <div class="console-container">

    <div class="name-container">
      <div class="row">
        <div class="col-3 d-flex justify-content-start align-items-center">
          <span>{{ title }}</span>
        </div>
        
        <div class="col-6 d-flex meduimname-container">
          <div class="card">
            <div class="ps-6">
              <div class="row">
                <div class="col-12 d-flex justify-content-start">
                  <div class="d-flex centerCnt">
                    <span [style.background-color]="agentStatusColor" class="dot-circle ms-2"></span>
                  </div>
                  <div class="label-margin centerCnt">{{ currStatusLabel }}</div>
                  <span class="status-margin centerCnt">{{ agentStatusDuration }}</span>
    
                  <div *ngIf="liveStatusControls">
                    <button *ngIf="managerViewBtn" class="outline-btn btn-sm ms-1"
                            type="submit" value="Start Live View" (click)="Startlivemoniter()">
                      <i class="bi bi-headset"></i> Start Live View
                    </button>
                    <button *ngIf="managerListenBtn" class="outline-btn btn-sm ms-1"
                            type="submit" value="Listen In" (click)="listenInPrep()">
                      <i class="bi bi-headset"></i> Listen In
                    </button>
                    <button *ngIf="managerDisconnectBtn" class="outline-btn btn-outline-danger btn-sm ms-1"
                            type="submit" value="Disconnect" (click)="listenInStop()">
                      <i class="bi bi-telephone-x-fill"></i> Disconnect
                    </button>
                    <button *ngIf="managerMuteOffBtn" class="outline-btn btn-outline-default btn-sm ms-1"
                            type="submit" value="Unmute" (click)="eManagerMuteBtnClickHandler()">
                      <i class="bi bi-mic-mute-fill"></i> Unmute
                    </button>
                    <button *ngIf="managerMuteOnBtn" class="outline-btn btn-outline-default btn-sm ms-1"
                            type="submit" value="Mute" (click)="eManagerMuteBtnClickHandler()">
                      <i class="bi bi-mic"></i> Mute
                    </button>
                    <button *ngIf="managerRemoteLogoffBtn" class="outline-btn btn-outline-danger btn-sm ms-1"
                            type="submit" value="Remote Log Off" (click)="RemoteLogOff()">
                      <i class="bi bi-box-arrow-in-left"></i> Remote Log Off
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    
        <div class="col-3">
          <div class="btn-grp d-flex justify-content-end align-items-center pt-3">
            <input class="main-btn" type="submit" value="Go Back" (click)="goBack()" />
            <input class="main-btn ms-2" [disabled]="!isEnabled" type="submit" value="Save Changes" (click)="saveChanges()" />
          </div>
        </div>
      </div>
    </div>

    <div class="details">
      <div class="heading">
        <span class="sub-heading">AGENT DETAILS</span>

        <hr class="solid-divider" />
      </div>
      <div class="row crud-container">
        <div class="form-group detail-field">
          <label for="agentName">Name</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="agentName"
            placeholder="Agent Name"
            [value]="historicalMetricDetail?.Name"
          />
        </div>

        <div class="form-group detail-field">
          <label for="agentemail">Email</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="agentemail"
            placeholder="Email"
            [value]="historicalMetricDetail?.Email"
          />
        </div>

        <div class="form-group detail-field">
          <label for="agentphone">Phone</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="agentphone"
            placeholder="Phone"
            [value]="historicalMetricDetail?.Phone"
          />
        </div>

        <div class="form-group detail-field">
          <label for="extension">Onvida Ext.</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="extension"
            placeholder="Extn."
            [value]="historicalMetricDetail?.Extension"
          />
        </div>
      </div>
    </div>

    <div class="details">
      <div class="heading">
        <span class="sub-heading">CURRENT QUEUE</span>

        <hr class="solid-divider" />
      </div>
      <div class="row crud-container">
        <div class="form-group detail-field">
          <label for="queueName">Name</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="queueName"
            placeholder="Queue Name"
            [value]="historicalMetricDetail?.LiveStatus?.QueueName"
          />
        </div>

        <div class="form-group detail-field">
          <label for="queueType">Type</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="queueType"
            placeholder="Type"
            [value]="historicalMetricDetail?.LiveStatus?.QueueType"
          />
        </div>

        <div class="form-group detail-field">
          <label for="queueLength">Length</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="queueLength"
            placeholder="Length"
            [value]="historicalMetricDetail?.LiveStatus?.QueueLength"
          />
        </div>
      </div>
    </div>

    <div class="details">
      <div class="heading">
        <span class="sub-heading">LAST INTERACTION</span>

        <hr class="solid-divider" />
      </div>
      <div class="row crud-container">
        <div class="form-group detail-field">
          <label for="interactioName">Name</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="interactioName"
            placeholder="Queue Name"
            [value]="historicalMetricDetail?.LiveStatus?.InteractionUser"
          />
        </div>

        <div class="form-group detail-field">
          <label for="company">Company</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="company"
            placeholder="Type"
            [value]="historicalMetricDetail?.LiveStatus?.InteractionCompany"
          />
        </div>

        <div class="form-group detail-field">
          <label for="location">Location</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="location"
            placeholder="Length"
            [value]="historicalMetricDetail?.LiveStatus?.InteractionLocation"
          />
        </div>
      </div>
    </div>
    <div class="switch-options">
    <div class="switch-row">
            <p-inputSwitch
              inputId="wrappermode"
              [disabled]="!isEnabled"
              [(ngModel)]="isDesktopOnly"
              styleClass="small-input-switch"
            />
            <label for="wrappermode" class="switch-text">Use wrapper only</label>
    </div>
    <div class="switch-row">
            <p-inputSwitch
              inputId="popups"              
              [disabled]="!isEnabled"
              [(ngModel)]="allowPopUps"
              styleClass="small-input-switch"
            />
            <label class="switch-text">Allow QNXT pop-up</label>
    </div>
    </div>
    
    <div class="sla-window-ctrls">
      <p-tabView>
        <p-tabPanel header="Queues">
          <p class="p-tab-content">
            <app-assign-agents (modifiedQueueData)="onSelectQueue($event)" [details]="queueDetails"></app-assign-agents>
          </p>
        </p-tabPanel>
        <p-tabPanel header="Skills">
          <p class="p-tab-content">
            <app-assign-agents (modifiedSkillData)="onSelectSkill($event)" [details]="skillDetails"></app-assign-agents>
          </p>
        </p-tabPanel>
        <p-tabPanel header="Interactions">
          <p class="p-tab-content">
            <app-livestatuses-interactions [interactionId]="selectedInteractionId"> </app-livestatuses-interactions>
          </p>
        </p-tabPanel>
        <p-tabPanel header="Audits">
          <p class="p-tab-content">
            <app-livestatuses-audits [interactionId]="selectedInteractionId"></app-livestatuses-audits>
          </p>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>
